import {openForethoughtAIChatbot} from "../../global/forethought-integration.util.js";

(function () {

    "use strict";

    var userProfileInfo = {};

    var app = angular.module('harriApp');

    app.directive('harriHeader', ['$timeout', '$state', 'OMISChecker', 'hUser', '$rootScope', 'hmapService', '$stateParams', 'userServices', 'interviewBankDataService', '$modal', 'localize', 'userPermissions', 'hEvent', 'brandServices', '$q', 'barriAnalyticsService', 'commshubService', '$filter', 'headerItemsService', 'talentPoolDataService', 'appLayoutViewService', 'userBusinessesService',
        function ($timeout, $state, OMISChecker, hUser, $rootScope, hmapService, $stateParams, userServices, interviewBankDataService, $modal, localize, userPermissions, hEvent, brandServices, $q, barriAnalyticsService, commshubService, $filter, headerItemsService, talentPoolDataService, appLayoutViewService, userBusinessesService) {
        return {
            restrict: 'E',
            templateUrl: '../scripts/global-directives/header/header.ng.html',
            scope: {
                'transparent': '=',
                'fixed': '=',
                'fluid': '=',
                'paddingBody': '=',
                'useBrandTheme': '='
            },
            link: function (scope, element, attrs) {
                var moreLinkWidth;
                //Decide where to direct user dashboard
                scope.getDashboardUrl = function () {
                    return $state.href('appLayout.harriSH.dashboard');
                };
                var brandId;

                var navBarPreference = [];

                scope.engagementItems = [
                    {
                        key: 'OBJ_ON_BOARDING',
                        label: $filter("translate")("My Welcome"),
                        availableBusinesses: [],
                        isVisible: false
                    },
                    {
                        key: 'HARRI_ENGAGE',
                        label: $filter("translate")("Engage"),
                        availableBusinesses: [],
                        isVisible: false
                    }
                ];

                var allHeaderItems = [
                    {
                        key: 'FIND_TALENT',
                        label: $filter("translate")('Find Talent'),
                        uiSref: {
                            name: 'appLayout.harriSH.search.people'
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn && scope.user.user_employer && !scope.isFromUK && scope.currentPage !== 'account-suspension';
                        }
                    },
                    {
                        key: 'FIND_JOBS',
                        label: $filter("translate")('Find Jobs'),
                        uiSref: {
                            name: 'appLayout.harriSH.search.jobs'
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return !scope.isLoggedIn && !scope.isFromUK;
                        }
                    },
                    {
                        key: 'RESOURCES',
                        label: $filter("translate")('Resources'),
                        href: 'https://resources.harri.com/',
                        target: '_blank',
                        isVisible: false,
                        checkVisibility: function () {
                            return !scope.isLoggedIn && !scope.isFromUK && scope.showCertainLinks;
                        }
                    },
                    {
                        key: 'PARTNERS',
                        label: $filter("translate")('Partners'),
                        href: '/partners',
                        isVisible: false,
                        checkVisibility: function () {
                            return !scope.isLoggedIn && !scope.isFromUK && scope.showCertainLinks;
                        }
                    },
                    {
                        key: 'ABOUT_US',
                        label: $filter("translate")('About Us'),
                        href: '/about-us',
                        isVisible: false,
                        checkVisibility: function () {
                            return !scope.isLoggedIn && !scope.isFromUK && scope.showCertainLinks;
                        }
                    },
                    {
                        key: 'REQUEST_A_DEMO',
                        label: $filter("translate")('Request a Demo'),
                        click: function () {
                            return scope.scheduleDemo('HIRE');
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return !scope.isLoggedIn && !scope.isFromUK && scope.currentPage !== 'appLayout.harriSH.search.jobs';
                        }
                    },
                    {
                        key: 'HOME',
                        notSortable: true,
                        label: $filter("translate")('Home'),
                        uiSref: {
                            name: 'homepage'
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return !scope.isLoggedIn && !scope.isFromUK;
                        }
                    },
                    {
                        key: 'LOGIN',
                        label: $filter("translate")('Login'),
                        isVisible: false,
                        checkVisibility: function () {
                            return !scope.isLoggedIn;
                        }
                    },
                    {
                        key: 'LOGOUT',
                        label: $filter("translate")('Logout'),
                        automation: 'menuLogoutLink',
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn && scope.currentPage === 'account-suspension';
                        }
                    },
                    {
                        key: 'HARRI_IQ_ONE_LINK',
                        label: 'Harri IQ',
                        modal_label:'Harri IQ',
                        badge: $filter("translate")('New'),
                        uiSref: {
                            name: 'appLayout.harriSH.harri-iq',
                            params: {route: 'liveboards'}
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && scope.isBarriEnabled
                                && scope.allowedBarriRoutes
                                && scope.allowedBarriRoutes.length === 1;
                        },
                    },
                    {
                        key: 'HARRI_IQ',
                        label: 'Harri IQ',
                        modal_label:'Harri IQ',
                        badge: $filter("translate")('New'),
                        //walkThroughCode
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && scope.isBarriEnabled
                                && scope.allowedBarriRoutes
                                && scope.allowedBarriRoutes.length > 1;
                        },
                        subItems: [
                            {
                                key: 'HARRI_IQ_HOME',
                                iconCssClasses: 'harri-iq-home-icon',
                                label: $filter("translate")('Home'),
                                uiSref: {
                                    name: "appLayout.harriSH.harri-iq",
                                    params: {
                                        route: 'home'
                                    }
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.allowedBarriRoutes && scope.allowedBarriRoutes.indexOf('home') > -1
                                }
                            },
                            {
                                key: 'HARRI_IQ_LIVEBOARDS',
                                label: $filter("translate")('My Liveboards'),
                                iconCssClasses: 'harri-iq-liveboards-icon',
                                uiSref: {
                                    name: "appLayout.harriSH.harri-iq",
                                    params: {
                                        route: 'liveboards'
                                    }
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.allowedBarriRoutes && scope.allowedBarriRoutes.indexOf('liveboards') > -1
                                }
                            },
                            {
                                key: 'HARRI_IQ_SEARCH',
                                label: $filter("translate")('Search Data'),
                                iconCssClasses: 'harri-iq-search-icon',
                                uiSref: {
                                    name: "appLayout.harriSH.harri-iq",
                                    params: {
                                        route: 'search'
                                    }
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.allowedBarriRoutes && scope.allowedBarriRoutes.indexOf('search') > -1
                                }
                            },
                            {
                                key: 'HARRI_IQ_SPOT_IQ',
                                label: $filter("translate")('My Spot IQ Results'),
                                iconCssClasses: 'harri-iq-spot-iq-icon',
                                uiSref: {
                                    name: "appLayout.harriSH.harri-iq",
                                    params: {
                                        route: 'spot-iq'
                                    }
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.allowedBarriRoutes && scope.allowedBarriRoutes.indexOf('spot-iq') > -1
                                }
                            }
                        ]
                    },
                    {
                        key: 'OBJ_ON_BOARDING',
                        label: scope.engagementItems.find(item => item.key === 'OBJ_ON_BOARDING')?.label,
                        isVisible: false,
                        checkVisibility: function () {
                            const engagementItem = scope.engagementItems.find((item) => item.key === 'OBJ_ON_BOARDING');
                            return scope.isLoggedIn && !scope.user.user_employer && engagementItem.availableBusinesses && engagementItem.availableBusinesses.length > 0;
                        }
                    },
                    {
                        key: 'HARRI_ENGAGE',
                        label: scope.engagementItems.find(item => item.key === 'HARRI_ENGAGE')?.label,
                        isVisible: false,
                        hasNotifications: false,
                        checkVisibility: function () {
                            const engagementItem = scope.engagementItems.find((item) => item.key === 'HARRI_ENGAGE');
                            return scope.isLoggedIn && !scope.user.user_employer && engagementItem.availableBusinesses && engagementItem.availableBusinesses.length > 0;
                        }
                    },
                    {
                        key: 'DASHBOARD',
                        label: $filter("translate")('dashboard'),
                        rel: "nofollow",
                        href: scope.getDashboardUrl(),
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && !scope.isTopLevelContext()
                                && scope.currentPage !== 'account-suspension'
                                && (!scope.isCustomDashEnabled || !scope.user.user_employer);
                        }
                    },
                    {
                        key: 'HIRING',
                        label: $filter("translate")('Hiring'),
                        rel: "nofollow",
                        uiSref: {
                            name: 'appLayout.harriSH.dashboard-hiring'
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && !scope.isTopLevelContext()
                                && scope.currentPage !== 'account-suspension'
                                && scope.isCustomDashEnabled
                                && !scope.isTTSDashboardEnabled
                                && scope.user.user_employer;
                        }
                    },
                    {
                        key: 'CARRI',
                        label: $filter("translate")('Carri'),
                        uiSref: {
                            name: 'carri.dashboard'
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && scope.isCarriEnabled;
                        }
                    },
                    {
                        key: 'MY_JOBS',
                        label: $filter("translate")('Recruitment hub'),
                        rel: "nofollow",
                        automation: "MyJobsIconButton",
                        uiSref: {
                            name: 'appLayout.harriSH.access-portal.jobs'
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && scope.hasAccessToSourceHire;
                        }
                    },
                    {
                        key: 'MY_DOCS',
                        label: $filter("translate")('Documents'),
                        uiSref: {
                            name: "appLayout.harriSH.docs",
                            params: {candidateState:''}
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && (
                                    !scope.user.user_employer ||
                                    (scope.isOnBoardingServiceEnabled && scope.onboardingPermission && scope.hasAccessToSourceHire)
                                );
                        }
                    },
                    {
                        key: 'MY_TEAM',
                        label: $filter("translate")('My Team'),
                        uiSref: {
                            name: "appLayout.schedule.core-hr.list",
                            params: {
                                source: 'TL'
                            },
                        },
                        automation: "headerTeamLink",
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && scope.user.user_employer
                                && !scope.isTopLevelContext()
                                && scope.teamSchedulingEnabled
                                && scope.hasAccessToTeam;
                        }
                    },
                    {
                        key: 'JOBS',
                        label: $filter("translate")('jobs'),
                        uiSref: {
                            name: "appLayout.harriSH.search.jobs"
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && !scope.user.user_employer
                                && !scope.isPrivacyShield
                                && !(scope.isFromUK && !scope.internalJobPostEnabled)
                        }
                    },
                    {
                        key: 'REFERRALS',
                        label: $filter("translate")('Referrals'),
                        uiSref: {
                            name: "employee-referrals"
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && !scope.user.user_employer
                                && scope.hasJobsReferrals;
                        }
                    },
                    {
                        key: 'TALENT_POOL',
                        label: $filter("translate")('Talent pool'),
                        automation: "TalentPoolIconButton",
                        click: function () {
                            return scope.goToTalentPool();
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && scope.user.user_employer
                                && scope.hasManageTalentPoolPermission
                                && (!scope.isTopLevelContext() || (scope.isGTPServiceEnabled && scope.hasAccessToSourceHire));
                        }
                    },
                    {
                        key: 'PMS',
                        label: $filter("translate")('Performance Management'),
                        automation: "PerformanceIconButton",
                        uiSref: {
                            name: "appLayout.harriSH.pms.dashboard"
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.isPMSEnabled
                                && scope.user.user_employer
                        }
                    },
                    {
                        key: 'TRAINING',
                        label: $filter("translate")('Training'),
                        automation: "LMSAccessTrainingButton",
                        uiSref: {
                            name: "lms.lms-employer-dashboard"
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && scope.isTopLevelContext()
                                && scope.isLMSServiceEnabled
                                && scope.isHMAPUser();
                        }
                    },
                    {
                        key: 'ELEARNING',
                        label: $filter("translate")('ELEARNING'),
                        automation: "LMSAccessTrainingButton",
                        uiSref: {
                            name: "elearning-northpass.elearning-northpass-manager-dashboard-learners"
                        },
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && scope.isTopLevelContext()
                                && scope.isHarriAcademyServiceEnabled
                                && scope.hasManageAdminsTraining
                                && scope.isHMAPUser();
                            }
                    },
                    {
                        key: 'REPORTS',
                        label: $filter("translate")('reports'),
                        uiSref: {
                            name: "appLayout.harriSH.reporting"
                        },
                        automation: "ReportsIconButton",
                        isVisible: false,
                        checkVisibility: function () {
                            return scope.isLoggedIn
                                && scope.currentPage !== 'account-suspension'
                                && scope.isTopLevelContext()
                                && scope.hasAccessToSourceHire
                                && scope.hasSalesAccess;
                        }
                    },
                ];

                var mainItemsKeysWithOriginalSort = allHeaderItems.map(function (item) {
                    return item.key;
                });

                scope.allHeaderItems = angular.copy(allHeaderItems);
                scope.headerItems = [];
                scope.moreItems = [];

                var sortHeaderItems = function () {
                    allHeaderItems = headerItemsService.sortHeaderItems(allHeaderItems, mainItemsKeysWithOriginalSort)
                    allHeaderItems = headerItemsService.sortHeaderItems(allHeaderItems, navBarPreference)
                }

                var processHeaderItems = function () {
                    allHeaderItems = headerItemsService.processHeaderItems(allHeaderItems);
                    sortHeaderItems();
                    handleHeaderItemsPosition();
                };

                var calculateItemsWidth = function () {
                    moreLinkWidth = $('#header-more-link').width();
                    allHeaderItems.forEach(function (item) {
                        item.width = $('#hidden-nav-container').find("[data-key='" + item.key + "']").width() || 0;
                    });
                };

                scope.checkHeaderItems = function () {
                    processHeaderItems();
                    return true;
                };

                var checkHasJobsReferrals = function () {
                    SocialReferralAPI.hasJobReferral()
                        .then(function (res){
                            scope.hasJobsReferrals = res.has_jobs_referrals;
                        })
                        .catch(function (err) {
                            console.error(err && err.data);
                        })
                        .finally(function () {
                            scope.$digest();
                        });
                }

                var checkEmployeeBusinessesForEngagement = function () {
                    userBusinessesService.getUserBusinesses().then(function (brands) {
                        scope.onBoardingJourneyItems = [];
                        scope.harriEngageItems = [];
                        if (brands && brands.length) {
                            for (let i = 0; i < brands.length; i++) {
                                if (brands[i].services) {
                                    if (brands[i].services.includes("ONBOARDING_JOURNEY")) {
                                        const onBoardingJourneyItem = createBrandItem(brands[i], "appLayout.harriSH.obj-candidate-events");
                                        const engagementItem = scope.engagementItems.find((item) => item.key === 'OBJ_ON_BOARDING');
                                        engagementItem.availableBusinesses.push(onBoardingJourneyItem);
                                    }
                                    if (brands[i].services.includes("HARRI_ENGAGE")) {
                                        const harriEngageItem = createBrandItem(brands[i], "light-communication-hub");
                                        const engagementItem = scope.engagementItems.find((item) => item.key === 'HARRI_ENGAGE');
                                        engagementItem.availableBusinesses.push(harriEngageItem);
                                    }
                                }
                            }
                            const engagementItem = scope.engagementItems.find((item) => item.key === 'OBJ_ON_BOARDING');
                            scope.isOnBoardingJourneyEnabled = !!engagementItem.availableBusinesses.length;
                        }

                        updateEngagementHeaderItems();
                        try {
                            scope.$digest();
                        } catch (e) {
                        }
                    });
                }

                function createBrandItem(brand, stateName) {
                    return {
                        image_uuid: brand.media[0]?.uuid,
                        image_path: brand.media[0]?.path,
                        isImageShown: true,
                        key: brand.name,
                        label: brand.name,
                        uiSref: {
                            name: stateName,
                            params: {
                                brand_id: brand.id
                            }
                        },
                        isSelected: brand.id == $stateParams.brand_id,
                        isVisible: true,
                        checkVisibility: function () {
                            return true;
                        }
                    };
                }

                function updateEngagementHeaderItems() {
                    scope.engagementItems.forEach((engagementItem) => {
                        allHeaderItems.forEach((headerItem) => {
                            if (headerItem.key === engagementItem.key) {
                                headerItem.subItems = engagementItem.availableBusinesses;
                            }
                        });
                    });
                }

                scope.toggleEngagementItemVisibility = function (engagementItem) {
                    engagementItem.isVisible = !engagementItem.isVisible;
                };

                function checkHasEngageUnreadMessages() {
                    TeamCommunicationAPI.getUnreadMessagesByModule("HARRI_ENGAGE")
                        .then(function (brands) {
                            if (brands?.length) {
                                const harriEngageHeaderItem = scope.headerItems.find((item) => item.key === 'HARRI_ENGAGE');
                                harriEngageHeaderItem.hasNotifications = true;
                            }
                        });
                }

                var getAcademyRedirectionLink = function() {
                    UserAPI.getAcademyLink()
                        .then(function(res) {
                           scope.academyRedirectionLink = res['redirection_link'];
                        })
                        .catch(function (err) {
                            console.error(err && err.data);
                        })
                        .finally(function () {
                            scope.$digest();
                        });
                };

                var resizeTimeout;
                var previousWidth;

                var handleHeaderItemsPosition = function (refresh) {
                    clearTimeout(resizeTimeout);
                    resizeTimeout = setTimeout(function () {
                        var availableWidth = $('#header-links-nav').outerWidth(true) - 20;
                        if (previousWidth && Math.abs(availableWidth - previousWidth) < 1) {
                            availableWidth = previousWidth;
                        }
                        allHeaderItems = headerItemsService.handleHeaderItemsPosition(allHeaderItems, availableWidth, moreLinkWidth);
                        var headerItems = allHeaderItems.filter(function (item) {
                            return !item.isInMore;
                        });
                        var moreItems = allHeaderItems.filter(function (item) {
                            return item.isInMore;
                        });
                        if (!headerItemsService.isSameItems(headerItems, scope.headerItems)
                            || !headerItemsService.isSameItems(moreItems, scope.moreItems)) {
                            scope.headerItems = headerItems;
                            scope.moreItems = moreItems;
                            scope.$digest();
                        }
                        previousWidth = availableWidth;
                    }, 10);
                };

                var getAllVisibleLinks = function () {
                    return allHeaderItems.filter(function (item) {
                        return item.isVisible;
                    });
                };

                var dontShowCustomDashWT = HStorageManager.get({
                    key: 'walk-through-dashs',
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                });
                var dontShowTTSWT = HStorageManager.get({
                    key: 'walk-through-tts',
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                });
                var dontShowBarriWT = HStorageManager.get({
                    key: 'walk-through-barri',
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                });

                scope.currentPage = $state.current.name;
                scope.fluid = true;
                scope.lang = localize.getLang();
                scope.isRTL = localize.isRTL();
                scope.allowedBarriRoutes;

                scope.showCertainLinks = ['appLayout.harriSH.search.jobs', 'appLayout.harriSH.search.people'].indexOf(scope.currentPage) === -1;

                // MOVE "Talent Pool" and "My Team" from header to side menu
                scope.moveItemsToSideMenu = ["de", "fr", "ru"].indexOf(scope.lang) > -1;

                $('body').addClass('header-available').removeClass('with-fixed-header');

                var headerHeight = 73;

                if (scope.paddingBody == true) {
                    $('body').addClass('with-fixed-header');
                }

                $(document).bind("scroll", window, function () {
                    if ($(this).scrollTop() > 70) {
                        $(".top-header").addClass("sticky-header");
                    } else {
                        $(".top-header").removeClass("sticky-header");
                    }
                });

                scope.isShowingGlobalSearch = function () {
                    return $state.current.showGlobalSearch && scope.isLoggedIn && hUser.isEmployer();
                };

                //some rendering details
                OMISChecker.renderOMISHeaderIfNeeded();
                hUser.isFromUK().then(function (fromUK) {
                    scope.isFromUK = fromUK ? fromUK : false;
                }, function (err) {
                    scope.isFromUK = false;
                    console.error(err);
                });

                scope.scheduleDemo = function (source) {
                    var data = "";
                    var analyticsData = $.extend({
                        label: source,
                        category:"salesRequest"
                    }, data);

                    hEvent.track('demo_request', analyticsData);

                    var modalData = function () {
                        return {
                            source: source,
                            type: 'demo_request'
                        };
                    };
                    ngLandingPagesUtils.handleRequestDemoClick(modalData);
                };

                scope.goToMyDocsHMAP = function () {
                    var parameters = {
                        candidateState: 'employees'
                    };

                    if (scope.activeBrandId) {
                        parameters['brandID'] = scope.activeBrandId;
                    }

                    if ($state.current.name != 'appLayout.harriSH.docs') {
                        $state.go('appLayout.harriSH.docs', parameters);
                    }
                };

                scope.goToTalentPool = function () {

                    var brandId, brandList;

                    if (hUser.isTopLevelContext() && $state.current.name !== 'appLayout.harriSH.talent-pool') {
                        brandId = hmapService.getActiveBrand();
                    }
                    else{
                        brandId = hUser.getUserContext().brand_id;
                    }

                    Utils.redirectToWorkspace('appLayout.harriSH.talent-pool', {
                        brandId: brandId
                    });
                };

                scope.goNextInWalkThrough = function (event) {

                    if (scope.walkThrough[scope.WTActive]) {
                        if (scope.walkThrough[scope.WTActive].code === 'custom_dash') {
                            HStorageManager.put({
                                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                key: 'walk-through-dashs',
                                value: true,
                                expiryDays: 3 * 365
                            });
                        }

                        if (scope.walkThrough[scope.WTActive].code === 'tts_dash') {
                            HStorageManager.put({
                                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                key: 'walk-through-tts',
                                value: true,
                                variables: {
                                    id: brandId
                                },
                                expiryDays: 3 * 365
                            });
                        }

                        if (scope.walkThrough[scope.WTActive].code === 'barri') {
                            HStorageManager.put({
                                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                key: 'walk-through-barri',
                                value: true,
                                expiryDays: 3 * 365
                            });
                        }
                    }

                    scope.WTActive++;

                    if (!scope.walkThrough[scope.WTActive]) {
                        scope.walkThrough = [];
                    }
                };

                scope.goToApprovalFlow = function () {
                    var brandId;
                    if (scope.user.brands_list.length === 1) {
                        brandId = scope.user.brands_list[0].id;
                    } else {
                        brandId = hUser.getUserContext().brand_id;
                    }
                    $state.go("appLayout.harriSH.job-approvals", {brandId: brandId});
                };

                var checkForWalkThrough = function () {
                    if (!scope.walkThrough) {

                        scope.WTActive = 0;
                        scope.walkThrough = [];

                        if (!dontShowCustomDashWT && scope.isCustomDashEnabled) {
                            scope.walkThrough.push({
                                code: 'custom_dash'
                            });
                        }
                        if (!dontShowBarriWT  && !scope.isBarriEnabled && false) {
                            scope.walkThrough.push({
                                code: 'barri'
                            });
                        }

                        if (!dontShowTTSWT && !hUser.isTopLevelContext() && scope.isTTSDashboardEnabled) {
                            scope.walkThrough.push({
                                code: 'tts_dash'
                            });
                        }

                        $timeout(function () {
                            scope.showAnimation = true;
                        }, 1000);
                    }
                };

                var setHeaderBranding = function (settings) {
                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                        key: 'brand_theme',
                        value: settings
                    });
                    scope.scheme_settings = settings && settings.scheme_settings;
                    scope.profile_image = (settings && settings.profile_image && settings.profile_image.uuid) ? settings.profile_image : null;
                    scope.rectangle_profile_image = (settings && settings.rectangle_profile_image && settings.rectangle_profile_image.uuid) ? settings.rectangle_profile_image : null;
                };

                var checkGlobalTalentPoolPermission = function () {
                    var brand_id = hmapService.getActiveBrand();
                    if (hUser.isTopLevelContext()) {
                        userPermissions.getBrandPolicy(brand_id)
                            .then(function (policyParser) {
                                scope.hasManageTalentPoolPermission = policyParser.brands(brand_id).has(userPermissions.PERMISSIONS.MANAGE_TALENT_POOL_MODULE);
                            });
                    } else {
                        talentPoolDataService.checkTalentPoolPermissionOnEnterpriseAndChild()
                            .then(function (res) {
                                scope.hasManageTalentPoolPermission = res;
                            });
                    }
                }

                var initHeader = function () {
                    userIdentifier = hUser.getUserBrandsIdentifier();
                    setHeaderBranding(HStorageManager.get({
                        key: 'brand_theme',
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                    }));
                    scope.hasJobPostPermission = false;
                    scope.onboardingPermission = false;
                    scope.isOnBoardingServiceEnabled = false;
                    scope.isJobApprovalFlowServiceEnabled = false;
                    scope.isHrActionsServiceEnabled = false;
                    scope.isLMSServiceEnabled = false;
                    scope.isHarriAcademyServiceEnabled = false;
                    scope.isLoggedIn = hUser.isLoggedIn();
                    scope.user = hUser.data.user;
                    scope.isGTPServiceEnabled = false;
                    scope.isCarriEnabled = false;
                    scope.isTTSDashboardEnabled = false;
                    scope.isCustomDashEnabled = false;
                    scope.hasManageBillingPermission = false;
                    scope.hasManageTalentPoolPermission = false;
                    scope.hasManageAdminsTraining = false;
                    scope.canAccessLiveSchedule = false;

                    if (!hUser.isTopLevelContext()) {
                        scope.isOnBoardingServiceEnabled = hUser.isOnboardingServiceEnabled();
                    }

                    //check if onboarding is enabled
                    scope.EVerifyEnabled = hUser.isEVerifyServiceEnabled();
                    scope.isJobDistributorEnabled = hUser.isJobDistributorEnabled();
                    var brandIds = _.pluck(scope.user.brands_list,'id');

                    if (hUser.isEmployer()) {
                        if (brandIds.length !== 1) {
                            brandIds.push(hUser.getUserContext()['brand_id']);
                        }
                        scope.brandIds = brandIds;
                        brandId = brandIds[0];
                        scope.hasSalesAccess = hUser.hasSalesAccess();
                        var checkServicesPromises = {
                            checkBrandServices: brandServices.checkAll(brandIds[0], [
                                brandServices.SERVICES.CARRI_RAPID_RESPONSE,
                                brandServices.SERVICES.PERFORMANCE_REVIEW,
                                brandServices.SERVICES.TTS_DASHBOARD,
                                brandServices.SERVICES.ENTERPRISE_COMMUNICATION,
                                brandServices.SERVICES.CUSTOM_DASHBOARD,
                                brandServices.SERVICES.ANALYTICS_BARRI,
                                brandServices.SERVICES.INDEED_CAMPAIGN_MANAGEMENT,
                            ], true),
                            checkCoreHrServices: brandServices.checkAll(hUser.getEntryMode().brand_id, [
                                brandServices.SERVICES.TEAM_SCHEDULING
                            ], true),
                            navBarPreference: headerItemsService.getNavBarPreference(
                                hUser.getUserContext().brand_id,
                                brandIds[0],
                                scope.isTopLevelContext() ? headerItemsService.ACCESS_LEVELS.HARRI_HMAP : headerItemsService.ACCESS_LEVELS.HARRI_ENTERPRISE
                            ),
                        };

                            $q.all(checkServicesPromises).then(function (response) {
                                navBarPreference = response['navBarPreference'];
                                sortHeaderItems();
                                var services = response['checkBrandServices'];
                                var checkCoreHrServices = response['checkCoreHrServices'];
                                scope.isCarriEnabled = services[brandServices.SERVICES.CARRI_RAPID_RESPONSE];
                                scope.isTTSDashboardEnabled = services[brandServices.SERVICES.TTS_DASHBOARD];
                                scope.isPMSEnabled = services[brandServices.SERVICES.PERFORMANCE_REVIEW];
                                scope.isCustomDashEnabled = services[brandServices.SERVICES.CUSTOM_DASHBOARD];
                                scope.isCommsHubEnabled = services[brandServices.SERVICES.ENTERPRISE_COMMUNICATION];
                                scope.isBarriEnabled = services[brandServices.SERVICES.ANALYTICS_BARRI];
                                scope.isTSServiceEnabled = checkCoreHrServices[brandServices.SERVICES.TEAM_SCHEDULING];
                                scope.isIndeedCampaignEnabled = services[brandServices.SERVICES.INDEED_CAMPAIGN_MANAGEMENT];
                                if (scope.isTSServiceEnabled) {
                                    LiveScheduleAPI.checkIfBrandHasAvailableShiftsEmailsService(hUser.getEntryMode().brand_id)
                                        .then(function (availableShiftsEnabled) {
                                            scope.canAccessLiveSchedule = availableShiftsEnabled;
                                        });
                                }
                                if (scope.isCommsHubEnabled) {
                                    getUnseenMessagesCount();
                                }
                                checkForWalkThrough();

                                if (scope.isBarriEnabled) {
                                    barriAnalyticsService.getUserBarriAllowedRoutes(brandIds[0], hUser.data.user.id)
                                        .then(function (allowedRoutes) {
                                            scope.allowedBarriRoutes = allowedRoutes;
                                            scope.$digest();
                                        });
                                }
                            });


                        brandServices.check(brandServices.SERVICES.MICE, brandIds[0]).then(function (isEnabled) {
                            if (isEnabled) {
                                MiceAPI.getEmployerMediaBranding().then(function (res) {
                                    setHeaderBranding(res);
                                }).finally(function () {
                                    scope.$digest();
                                });
                            } else {
                                setHeaderBranding(null);
                            }
                        });

                        hmapService.onGPPolicyLoaded(function () {
                            checkGlobalTalentPoolPermission();
                        });

                        hmapService.onActiveBrandChanged(function () {
                            checkGlobalTalentPoolPermission();
                        });

                        checkGlobalTalentPoolPermission();

                        userPermissions.getBrandPolicy(brandIds)
                            .then(function (policyParser) {
                                scope.hasManageAdminsTraining = policyParser.has(userPermissions.LMS['MANAGE_ADMIN_TRAINING']);
                                scope.hasJobPostPermission = policyParser.brands(policyParser.ANY).hasAny(userPermissions.CREATE_JOB_PERMISSIONS);
                                scope.onboardingPermission = policyParser.brands(policyParser.ANY).hasAny(userPermissions.VIEW_ONBOARDING);
                                scope.hasEverifyPermission = policyParser.brands(policyParser.ANY).has(userPermissions.PERMISSIONS.I_9_REVIEW_AND_E_VERIFY);
                                scope.hasAccessToSourceHire = policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE);
                                scope.hasAccessToTeam = policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM);
                                scope.teamSchedulingEnabled = hUser.isTeamSchedulingEnabled();
                                scope.hasManageBillingPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_BILLING_DETAILS);
                                scope.hasOverrideApprovalsPermission = policyParser.brands(policyParser.ANY).has(userPermissions.PERMISSIONS.OVERRIDE_APPROVALS);
                                scope.hasTeamlivePositionPermission = policyParser.brands(policyParser.ANY).has(userPermissions.PERMISSIONS.APPROVE_TEAMLIVE_POSITION);
                                scope.hasTeamliveLocationPeriodPermission = policyParser.brands(policyParser.ANY).has(userPermissions.PERMISSIONS.APPROVE_TEAMLIVE_LOCATION_PERIOD);
                                var canViewHrActionsTab = policyParser.has(userPermissions.PERMISSIONS.VIEW_HR_ACTIONS);
                                var hasOverrideJobApprovalPermission = policyParser.has(userPermissions.PERMISSIONS.OVERRIDE_APPROVALS);
                                var hasHrActionsApprovalsPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_HR_ACTIONS_APPROVALS);
                                //check if AtrService & jobApprovalService are enabled for M&B on (enterprise - child) level
                                if (!hUser.isTopLevelContext() && hUser.isLoggedIn() && hUser.data.user.brands_list && hUser.data.user.brands_list.length) {
                                    var promises = {
                                        'isATRServiceEnabled': brandServices.check(brandServices.SERVICES.ATR, scope.user.brands_list[0].id),
                                        'isJobApprovalFlowServiceEnabled': brandServices.check(brandServices.SERVICES.JOB_APPROVAL_FLOW, scope.user.brands_list[0].id),
                                        'isHrActionsServiceEnabled': brandServices.check(brandServices.SERVICES.HR_ACTIONS, scope.user.brands_list[0].id),
                                        'isLMSServiceEnabled': brandServices.check(brandServices.SERVICES.LMS, hUser.getEntryMode().brand_id),
                                        'isHarriAcademyServiceEnabled': brandServices.check(brandServices.SERVICES.HARRI_ACADEMY, hUser.getEntryMode().brand_id),
                                        'enabledApprovalFlowsSettings': ApprovalFlowAPI.getBrandApprovalFlowSettings(scope.user.brands_list[0].id)
                                    };
                                    promises[userServices.SERVICES.APPROVAL_FLOW] = userServices.isServiceEnabled(userServices.SERVICES.APPROVAL_FLOW, scope.user.brands_list[0].id);

                                    $q.all(promises)
                                        .then(function (res) {
                                            var isATREnabled = res['isATRServiceEnabled'];
                                            var isHrActionsServiceEnabled = res['isHrActionsServiceEnabled'];
                                            scope.isJobApprovalFlowServiceEnabled = res['isJobApprovalFlowServiceEnabled'];
                                            scope.isLMSServiceEnabled = res['isLMSServiceEnabled'];
                                            scope.isHarriAcademyServiceEnabled = res['isHarriAcademyServiceEnabled'];
                                            scope.teamlive_location_period_enabled =
                                                res['enabledApprovalFlowsSettings'] &&
                                                res['enabledApprovalFlowsSettings'].settings &&
                                                res['enabledApprovalFlowsSettings'].settings.teamlive_location_period_enabled;
                                            scope.teamlive_position_enabled =
                                                res['enabledApprovalFlowsSettings'] &&
                                                res['enabledApprovalFlowsSettings'].settings &&
                                                res['enabledApprovalFlowsSettings'].settings.teamlive_position_enabled;

                                            scope.isApprovalFlowEnabled =
                                                !!res[userServices.SERVICES.APPROVAL_FLOW] &&
                                                (
                                                    scope.hasOverrideApprovalsPermission ||
                                                    (scope.teamlive_position_enabled) ||
                                                    (scope.teamlive_location_period_enabled)
                                                );

                                            scope.canManageHrActionsAprovals = isHrActionsServiceEnabled && canViewHrActionsTab && (hasOverrideJobApprovalPermission || hasHrActionsApprovalsPermission);

                                            if (isATREnabled) {

                                                ATRAPI.getBrandSettings(scope.user.brands_list[0].id)
                                                    .then(function (atrSettings) {
                                                        if (atrSettings.atr_type === "MB") {
                                                            scope.isATRWithMBEnabled = true;
                                                        }
                                                    })
                                                    .catch(function (err) {
                                                        console.error(err);
                                                    })
                                                    .finally(function () {
                                                        scope.$digest();
                                                    });
                                            }
                                            if(scope.isLMSServiceEnabled) {
                                                getAcademyRedirectionLink();
                                            }
                                        })
                                        .catch(function (err) {
                                            console.error(err);
                                        });
                                }
                            });
                    }
                    else {
                        MiceAPI.getCandidateMediaBranding().then(function (res) {
                            setHeaderBranding(res);
                        });

                        if (scope.user.team_user_id) {
                            checkHasJobsReferrals();
                            checkEmployeeBusinessesForEngagement();
                            checkHasEngageUnreadMessages();
                        }

                        CandidateAPI.candidateBrandServicesCheck('PRIVATE_JOB_POST', true, true).then(function (data) {
                            scope.internalJobPostEnabled = !!(data.brands && data.brands.length);
                        });
                    }

                    scope.isPrivacyShield = hUser.isPrivacyShieldOn();


                    if (scope.isHMAPUser() && hUser.isTopLevelContext()) {
                        scope.activeBrandId = $stateParams.brandID || hmapService.getActiveBrand();
                        scope.isOnBoardingServiceEnabled = false;

                        hmapService.loadGPPlociy(scope.activeBrandId)
                            .then(function (policy) {

                                scope.activeBrandPolicy = _.find(policy.brands, function (entry) {
                                    return entry.id == scope.activeBrandId;
                                });

                                for (var i in scope.activeBrandPolicy.services) {

                                    if (scope.activeBrandPolicy.services[i].code === "ON_BOARDING") {
                                        scope.isOnBoardingServiceEnabled = true;
                                    }

                                    if (scope.activeBrandPolicy.services[i].code === brandServices.SERVICES.LMS) {
                                        scope.isLMSServiceEnabled = true;
                                    }

                                    if (scope.activeBrandPolicy.services[i].code === brandServices.SERVICES.HARRI_ACADEMY) {
                                        scope.isHarriAcademyServiceEnabled = true;
                                    }

                                    if (scope.activeBrandPolicy.services[i].code === brandServices.SERVICES.GLOBAL_TALENT_POOL) {
                                        scope.isGTPServiceEnabled = true;
                                    }

                                }

                                try {
                                    scope.$digest();
                                } catch (e) {

                                }
                            });

                    }
                };

                //@TODO: refactor
                scope.profileInfo = {};

                var userIdentifier;

                var userUpdatedEvent = $rootScope.$on('user_updated', function (event) {
                    if (userIdentifier !== hUser.getUserBrandsIdentifier()) {
                        initHeader();
                        // Safe digest
                        try { scope.$$phase || scope.$digest() } catch (e) {}
                    }
                });

                var commsHubMessagesCountEvent = commshubService.on('unread_messages_changed', function () {
                    commshubService.reset();
                    getUnseenMessagesCount();
                });

                //is top level user GP-1, GP-2...
                scope.isTopLevelContext = function() {
                    return hUser.isTopLevelContext();
                };

                scope.isHMAPUser = function () {
                    return hUser.isEmployer() ? hUser.isHMAPUser() : false;
                };

                //Hello Logout :)
                scope.logout = function () {
                    return hUser.logout();
                };

                scope.getLogoLink = function(){
                    if (hUser.isPrivacyShieldOn()) {
                        return '#';
                    }
                    if (scope.isAccountSuspensionServiceEnabled && scope.currentPage === 'account-suspension') {
                        return '#';
                    }

                    return !hUser.isTopLevelContext() ? '/' : $state.href('appLayout.harriSH.access-portal.main');
                };

                if (hUser.isLoggedIn()) {
                    initHeader();
                } else if (scope.useBrandTheme) {
                    if (appLayoutViewService.getBrandTheme()) {
                        setHeaderBranding(appLayoutViewService.getBrandTheme())
                    } else {
                        var brandThemeEvent = appLayoutViewService.on('theme_update', function (theme) {
                            setHeaderBranding(theme)
                        })
                    }
                }

                //Unseen messages count
                var getUnseenMessagesCount = function() {
                    TeamCommunicationAPI.getUnreadMessagesCount()
                        .then(function(count) {
                            scope.unseenMessagesCount = count;

                        }).finally(function () {
                        scope.$digest();
                    });
                };

                var closeBrandsList = function(){
                    scope.showBrandsList = false;
                    setTimeout(function () {
                        $(document).off("click.brands-dropdown");
                    },10);

                };

                scope.selectBrand = function(){
                    closeBrandsList();
                };

                scope.openBrandsList = function () {
                    scope.showBrandsList = true;
                    setTimeout(function () {
                        $(document).on("click.brands-dropdown", function (event) {
                            if (scope.showBrandsList) {
                                if ($(event.target).parents(".h-brand-list-wrapper").length === 0) {
                                    closeBrandsList();
                                    scope.$digest();
                                }
                            }
                        });
                    },10);
                };

                scope.openForethoughtChatBot = () => {
                    openForethoughtAIChatbot(localize.getLang());
                }

                $(window).on("focus.message_center", function () {
                    if (hUser.isLoggedIn()) {
                        $rootScope.$broadcast('updateHeaderNotf');
                    }
                });

                scope.openLinksPreferencesModal = function () {
                    $modal({
                        controller: 'headerLinksPreferencesModalController',
                        controllerAs: '$ctrl',
                        templateUrl: '../scripts/global-directives/header-links-preferences-modal/header-links-preferences.modal.html',
                        show: true,
                        backdrop: 'static',
                        resolve: {
                            modalData: function () {
                                return {
                                    brandId: brandId,
                                    groupId: hUser.getUserContext().brand_id,
                                    links: getAllVisibleLinks(),
                                    accessLevel: scope.isTopLevelContext() ? headerItemsService.ACCESS_LEVELS.HARRI_HMAP : headerItemsService.ACCESS_LEVELS.HARRI_ENTERPRISE
                                };
                            },
                            onSave: function () {
                                return function (preferences) {
                                    navBarPreference = preferences;
                                    sortHeaderItems();
                                };
                            }
                        }
                    });
                };

                setTimeout(function () {
                    calculateItemsWidth();
                    $('#hidden-nav-container').remove();
                }, 1);

                $(window).on('resize.header', handleHeaderItemsPosition);

                //remove all binded
                scope.$on("$destroy", function () {
                    commshubService.off(commsHubMessagesCountEvent);
                    brandThemeEvent && appLayoutViewService.off(brandThemeEvent)
                    userUpdatedEvent();
                    //remove class added to body
                    $('body').removeClass('header-available')
                        .removeClass('with-fixed-header');
                    $(window).off("focus.message_center");
                    $(window).off('resize.header');
                });
            }
        }
    }]);
})();

